import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-elapsed-time',
    templateUrl: './elapsed-time.component.html',
    styleUrls: ['./elapsed-time.component.css'],
    standalone: false
})
export class ElapsedTimeComponent implements OnInit {
  value = 0;
  minutes = 0;
  @Input() timeStart: any;
  @Input() timeEnd: any;
  @Input() status: number;
  @Input() fromClaim: boolean;
  progressType = 'bar-success';
  tooltipStr = '';
  groups = [];
  constructor() { }

  getString(diff) {
    let days, hours, minutes, str = '';
    diff = Math.abs(diff);
    days = Math.floor(diff / 3600 / 24);
    diff = diff - days * 3600 * 24;
    hours = Math.floor(diff / 3600);
    minutes = Math.floor((diff - hours * 3600) / 60);
    if (hours < 1) {
      if (minutes < 10) {
        str += '00:0' + minutes;
      } else {
        str += '00:' + minutes;
      }
    } else {
      if (hours < 10) {
        str += '0' + hours;
      } else {
        str += hours;
      }
      if (minutes < 10) {
        str += ':0' + minutes;
      } else {
        str += ':' + minutes;
      }
      if (days >= 1) {
        str = days + ' days ' + str;
      }
    }
    return str;
  }


  ngOnInit() {
    /*
    status:
    1: open
    2: closed
    */
    const s = new Date(this.timeStart), _s = new Date(), gmtMins = -_s.getTimezoneOffset() * 60;
    let diff;
    if (this.status == 1) { // Opened state
      diff = Math.floor((Date.now() - s.getTime()) / 1000) - gmtMins;
    } else if (this.status == 2) { // Closed state
      const e = new Date(this.timeEnd);
      diff = Math.floor((e.getTime() - s.getTime()) / 1000);
    } else {
      diff = 0;
    }
    if (this.fromClaim === true) {
      this.claimInterval(diff);
    } else {
      this.caseInterval(diff);
    }

  }

  caseInterval(diff) {
    if (diff > 30 * 60) {
      this.progressType = 'bar-danger';
      this.value = 100;
      this.tooltipStr = this.getString(diff);
    } else {
      let n = Math.floor(diff / 180);
      if (n > 2) {
        n = 2;
      }
      for (let i = 0; i < n; i ++) {
        this.groups.push({percent: 100 / 3});
      }
      const percent_per_group = 100 / 3;
      const interval = setInterval(() => {
        this.tooltipStr = '';
        let s = new Date(this.timeStart), minutes, seconds,
        _s = new Date(), gmtMins = -_s.getTimezoneOffset() * 60;
        let diff;
        if (this.status === 1) { // Opened state
          diff = Math.floor((Date.now() - s.getTime()) / 1000) - gmtMins;
        } else if (this.status === 2) { // Closed state
          const e = new Date(this.timeEnd);
          diff = Math.floor((e.getTime() - s.getTime()) / 1000);
        } else { // Other state, Reserved
          diff = 0;
        }
        diff = Math.abs(diff);
        minutes = Math.floor(diff / 60);
        seconds = diff - minutes * 60;
        this.minutes = minutes;
        if (minutes < 10) {
          this.tooltipStr += '00:0' + minutes;
        } else {
          if (minutes >= 29) {
            this.progressType = 'bar-warning';
          }
          this.tooltipStr += '00:' + minutes;
        }
        this.value = Math.floor(diff / (30 * 60) * 100);

        if (this.value >= 100) {
          this.progressType = 'bar-danger';
          this.value = 100;
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  claimInterval(diff) {
    if (diff > 3 * 24 * 3600) {
      this.progressType = 'bar-danger';
      this.value = 100;
      this.tooltipStr = this.getString(diff);
    } else {
      const interval = setInterval(() => {
        this.tooltipStr = '';
        let s = new Date(this.timeStart), days, hours,
        _s = new Date(), gmtMins = -_s.getTimezoneOffset() * 60;
        let diff;
        if (this.status === 1) { // Opened state
          diff = Math.floor((Date.now() - s.getTime()) / 1000) - gmtMins;
        } else if (this.status === 2) { // Closed state
          const e = new Date(this.timeEnd);
          diff = Math.floor((e.getTime() - s.getTime()) / 1000);
        } else { // Other state, Reserved
          diff = 0;
        }
        this.tooltipStr = this.getString(diff);
        days = Math.floor(diff / (24 * 3600));
        hours = Math.floor((diff - days * 24 * 3600) / 3600);
        if (days === 2 && hours >= 12) {
          this.progressType = 'bar-warning';
        }
        this.value = Math.floor(diff / (3 * 24 * 3600) * 100);
        if (this.value >= 100) {
          this.progressType = 'bar-danger';
          this.value = 100;
          clearInterval(interval);
        }
      }, 1000);
    }
  }
}
